import React, {Component} from 'react'
import Helmet from "react-helmet";
import {Button,Icon} from 'antd'
import BindCourse from './images/bind-course.jpg'
import './subscribe.less'

class CompanyBindOpt extends Component {
    state={

    }

    componentWillMount() {

    }

    componentDidMount() {

    }

    onBack = () => {
        this.props.history.replace('/sub')
    }
    render () {
        return (
            <div className='mobile-upload'>
                <Helmet
                    meta={[
                        {name: "viewport", content: "width=device-width,initial-scale=1.0,user-scalable=no"},
                    ]}
                    title="呜呜网"
                />
                <div className='company-bind'>
                    <div className="company-bind-left" onClick={this.onBack}>
                        <Icon type="left" />
                    </div>
                    <div className="company-bind-title">
                        企业关注教程
                    </div>
                </div>
                <div className="company-bind-info">
                    <img src={BindCourse} alt="BindCourse"/>
                </div>
                
            </div>

        );
    }
}
export default CompanyBindOpt